import { useText } from 'preact-i18n'
import { ExpandableItemsListDrawer } from '../../molecules/ExpandableBarcodeList/ExpandableBarcodeList'
import { useVinPauseFlow, type FlowProps } from '../../../hooks'
import { useStore } from '../../../store'
import type AppStore from '../../../store/AppStore'

export function useVinCodeFlow(store: AppStore, notificationText: string): FlowProps {
  return useVinPauseFlow(store, notificationText)
}

export default function VinCodeExpandableList() {
  const store = useStore()
  const { tapToResume } = useText({ tapToResume: 'vin.tapToResume' })
  const flow = useVinCodeFlow(store, tapToResume ?? 'Tap Anywhere to Resume')
  return <ExpandableItemsListDrawer {...flow} />
}
